import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35233e63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "board-map-wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "report" }
const _hoisted_4 = { class: "chart-container" }

import L from 'leaflet'
import {
  ref,
  onMounted,
  onUnmounted,
  nextTick,
} from 'vue'
import Text from '@/components/text'
import * as echarts from 'echarts'
import { queryBoardReportDetail } from '@/api'
import { CODE_ENUM } from '@/common'
import { getLineColor } from '@/utils'
import { cloneDeep, set, get, isEmpty } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'b-chart',
  props: ['id', 'name'],
  emits: 'on-edit',
  setup(__props, { emit: $emit }) {

const props = __props;




const option = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  grid: {
    left: 55,
    right: 40,
    top: 70,
    bottom: 30,
  },
  legend: {
    right: 30,
    top: 10,
  },
  xAxis: [
    {
      type: 'category',
      axisTick: { show: false },
      data: ['2012', '2013', '2014', '2015', '2016'],
    },
  ],
  yAxis: [
    {
      type: 'value',
    },
  ],
  series: [],
}

onMounted(() => {
  // window.addEventListener('resize', resizeCharts)
  // myChart = echarts.init(chartRef.value)
  // myChart.setOption(option)
  queryData()
})

const deviceRef = ref()
const loading = ref(false)
let myChart: any = null
const queryData = async () => {
  loading.value = true
  const res: any = await queryBoardReportDetail({
    id: props.id,
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const { pointStatisticsMap = {} } = res.data || {}

    const keys = Object.keys(pointStatisticsMap)

    let moXaxis = null
    const series = keys.map((key: string, index: number) => {
      const { xaxis, yaxis, config, formatter } = pointStatisticsMap[key]
      moXaxis = xaxis
      return {
        data: yaxis,
        type: 'bar',
        ...config,
        ...getLineColor(index),
        // 不让断开
        connectNulls: true,
        showAllSymbol: true,
        formatter,
        tooltip: {
          valueFormatter: tooltipFomatter(formatter),
        },
      }
    })

    const seriesData = series.map((item: any) => item.data)
    if (isEmptyData(seriesData.flat(Infinity))) {
      clearChart()
      return
    }
    const ops = cloneDeep(option)

    set(ops, 'series', series)
    set(ops, 'xAxis[0].data', moXaxis)

    clearChart()
    myChart = echarts.init(deviceRef.value)
    console.log(deviceRef.value, 'deviceRef.value')
    showEmpty.value = false
    myChart.setOption(ops)
  } else if (res?.code === 30900) {
    showEmpty.value = true
    clearChart()
  }
}

const clearChart = () => {
  myChart?.clear?.()
  myChart?.dispose?.()
  myChart = null
}

const resizeCharts = () => {
  myChart?.resize?.()
}

const showEmpty = ref(false)
const isEmptyData = (list: any) => {
  const reslut = list.filter((data: any) => data !== null).length === 0
  showEmpty.value = reslut
  return reslut
}

const tooltipFomatter = (formatter: string) => {
  return (value: string) => {
    return value !== null && value !== undefined
      ? value + (formatter || '')
      : '-'
  }
}

const command = (command: string) => {
  $emit(command)
}

return (_ctx: any,_cache: any) => {
  const _component_MoreFilled = _resolveComponent("MoreFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Text), {
        content: props.name
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.name), 1)
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_el_dropdown, {
        onCommand: command,
        size: "small",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { command: "on-edit" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.bedit')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { command: "on-delete" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.bdel')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { class: "icon" }, {
            default: _withCtx(() => [
              _createVNode(_component_MoreFilled)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", {
          ref_key: "deviceRef",
          ref: deviceRef,
          class: "chart-box"
        }, null, 512),
        (showEmpty.value)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              class: "empty",
              description: _ctx.$t('STATISTICS.noData')
            }, null, 8, ["description"]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, loading.value]
      ])
    ])
  ]))
}
}

})